(function () {
  var cfg = window.AM_VIP || {};
  var VIP_CODE = cfg.code || 'VIP40MANTON';
  var VIP_AMOUNT = cfg.amount || 40;
  var applying = false;
  var checkoutArmed = false;

  function routesRoot() {
    return (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  }

  function isVip() {
    return localStorage.getItem('vip_subscriber') === '1';
  }

  function setVipClass() {
    if (isVip()) document.documentElement.classList.add('is-vip');
  }

  function isEligiblePrice(priceEl) {
    return priceEl.hasAttribute('data-vip-eligible') || !!priceEl.closest('[data-vip-eligible]');
  }

  function parseMoney(text) {
    var match = String(text).match(/[\d]+[.,]\d{2}/);
    if (!match) return NaN;
    return parseFloat(match[0].replace(/\./g, '').replace(',', '.'));
  }

  function formatMoney(num) {
    return num.toFixed(2).replace('.', ',');
  }

  function applyVipPrice() {
    if (!isVip()) return;
    document.querySelectorAll('[data-price]').forEach(function (priceEl) {
      if (!isEligiblePrice(priceEl)) return;
      var raw = priceEl.textContent.trim();
      if (!raw || raw.indexOf('VIP') !== -1) return;
      var num = parseMoney(raw);
      if (isNaN(num) || num <= VIP_AMOUNT) return;
      var wrap = priceEl.closest('.product__price') || priceEl.parentElement;
      var compareEl = wrap && wrap.querySelector('[data-compare-price]');
      if (compareEl) {
        compareEl.textContent = raw;
        compareEl.style.display = 'inline';
      }
      priceEl.innerHTML =
        formatMoney(num - VIP_AMOUNT) +
        ' <span class="vip-badge-pdp" style="font-size:0.6em;background:#1a1a1a;color:#fff;padding:3px 8px;border-radius:3px;margin-left:8px;">VIP &#8722;' +
        VIP_AMOUNT +
        '&euro;</span>';
    });
  }

  function applyVipBadges() {
    if (!isVip()) return;
    document.querySelectorAll('[data-vip-eligible]').forEach(function (el) {
      if (el.hasAttribute('data-price') || el.querySelector('[data-price]')) return;
      if (el.querySelector('.vip-badge-coll')) return;
      var badge = document.createElement('span');
      badge.className = 'vip-badge-coll';
      badge.style.cssText =
        'font-size:0.65em;background:#1a1a1a;color:#fff;padding:2px 6px;border-radius:3px;margin-left:6px;vertical-align:middle;letter-spacing:0.5px;';
      badge.textContent = 'VIP';
      el.appendChild(badge);
    });
  }

  function cartHasVipCode(cart) {
    if (!cart) return false;
    var apps = cart.cart_level_discount_applications || [];
    for (var i = 0; i < apps.length; i++) {
      if (String(apps[i].title || '').indexOf(VIP_CODE) !== -1) return true;
    }
    var items = cart.items || [];
    for (var i = 0; i < items.length; i++) {
      var discs = items[i].discounts || [];
      for (var j = 0; j < discs.length; j++) {
        if (String(discs[j].title || '').indexOf(VIP_CODE) !== -1) return true;
      }
      var allocs = items[i].line_level_discount_allocations || [];
      for (var j = 0; j < allocs.length; j++) {
        var title =
          (allocs[j].discount_application && allocs[j].discount_application.title) || '';
        if (String(title).indexOf(VIP_CODE) !== -1) return true;
      }
    }
    var codes = cart.discount_codes || [];
    for (var i = 0; i < codes.length; i++) {
      if (
        String(codes[i].code || '').toUpperCase() === VIP_CODE &&
        codes[i].applicable !== false
      ) {
        return true;
      }
    }
    return false;
  }

  function postCartDiscount(code) {
    return fetch(routesRoot() + 'cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      credentials: 'same-origin',
      body: JSON.stringify({ discount: code }),
    }).then(function (r) {
      return r.json();
    });
  }

  function applyVipDiscount() {
    if (!isVip() || applying) return Promise.resolve(null);
    applying = true;
    return postCartDiscount(VIP_CODE)
      .then(function (cart) {
        if (cart && cart.status && cart.status !== 200) {
          applying = false;
          return null;
        }
        if (cart && cart.item_count > 0 && !cartHasVipCode(cart)) {
          return postCartDiscount('').then(function () {
            applying = false;
            return null;
          });
        }
        applying = false;
        return cart;
      })
      .catch(function () {
        applying = false;
        return null;
      });
  }

  function activateVip() {
    localStorage.setItem('vip_subscriber', '1');
    setVipClass();
    applyVipPrice();
    applyVipBadges();
    if (cfg.pageEligible) applyVipDiscount();
  }

  function checkHash() {
    if (window.location.hash.indexOf('vip') !== -1) {
      activateVip();
      try {
        window.history.replaceState(
          {},
          '',
          window.location.pathname + window.location.search
        );
      } catch (e) {}
    }
  }

  function checkQuery() {
    if (window.location.search.indexOf('vip=1') === -1) return;
    activateVip();
    try {
      var cleanUrl = window.location.href.replace(/[?&]vip=1/, '').replace(/[?&]$/, '');
      window.history.replaceState({}, '', cleanUrl);
    } catch (e) {}
  }

  function watchPrices() {
    document.querySelectorAll('[data-price]').forEach(function (priceEl) {
      if (!isEligiblePrice(priceEl) || priceEl.getAttribute('data-vip-observed')) return;
      priceEl.setAttribute('data-vip-observed', '1');
      new MutationObserver(applyVipPrice).observe(priceEl, {
        childList: true,
        characterData: true,
        subtree: true,
      });
    });
  }

  document.addEventListener(
    'click',
    function (e) {
      var addBtn = e.target.closest('[data-add-to-cart], button[name="add"]');
      if (addBtn && isVip()) {
        setTimeout(function () {
          applyVipDiscount();
        }, 900);
      }

      var checkoutBtn = e.target.closest('[name="checkout"]');
      if (!checkoutBtn || !isVip() || checkoutArmed) return;
      e.preventDefault();
      e.stopPropagation();
      applyVipDiscount().then(function (cart) {
        if (cartHasVipCode(cart)) {
          window.location.href =
            routesRoot() +
            'discount/' +
            encodeURIComponent(VIP_CODE) +
            '?redirect=/checkout';
          return;
        }
        checkoutArmed = true;
        var form = checkoutBtn.closest('form');
        if (form) form.submit();
        else checkoutBtn.click();
      });
    },
    true
  );

  window.addEventListener('hashchange', checkHash);
  checkHash();
  checkQuery();
  setVipClass();
  applyVipPrice();
  applyVipBadges();
  watchPrices();

  if (isVip() && cfg.pageEligible) applyVipDiscount();

  new MutationObserver(function () {
    applyVipBadges();
    watchPrices();
  }).observe(document.body, { childList: true, subtree: true });

  setInterval(function () {
    applyVipPrice();
    applyVipBadges();
  }, 2000);
})();
